<script setup>
const props = defineProps({
  id: {
    type: [String, Number],
    default: undefined,
  },
  name: {
    type: String,
    default: undefined,
  },
  city: {
    type: String,
    default: undefined,
  },
  countryCode: {
    type: String,
    default: undefined,
  },

  placeholder: {
    type: String,
    default: undefined,
  },

  iconName: {
    type: String,
    default: undefined,
  },
  showFlag: {
    type: Boolean,
    default: true,
  },

  disablePaddings: {
    type: Boolean,
    default: false,
  },
});

const showCity = computed(() => props.city && props.city !== props.name);
</script>

<template>
  <button
    type="button"
    class="ui-station-button"
    :class="{ 'ui-station-button--with-paddings': !disablePaddings }"
  >
    <slot name="icon">
      <CIcon v-if="iconName" :name="iconName" class="ui-station-button__icon" />
    </slot>

    <span class="ui-station-button__wrapper">
      <span
        class="ui-station-button__name"
        :class="{ 'ui-station-button__name--empty': !name }"
      >
        <span class="ui-station-button__font" :title="name || placeholder">
          {{ name || placeholder }}
        </span>
      </span>

      <span v-if="showCity" class="ui-station-button__city">
        <span class="ui-station-button__font">
          {{ city }}
        </span>
      </span>
    </span>

    <span v-if="countryCode" class="ui-station-button__code">
      <CCountryFlag
        v-if="showFlag"
        class="ui-station-button__flag"
        :code="countryCode"
      />

      <span v-else class="ui-station-button__font">
        {{ countryCode }}
      </span>
    </span>
  </button>
</template>
